import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { X, Zap, TrendingUp, Shield, CheckCircle } from 'lucide-react';
import { useGroupFeatures } from '../hooks/useGroupFeatures.ts';

const UpgradePromptCard = () => {
  const navigate = useNavigate();
  const { hasFeature } = useGroupFeatures();
  const [isDismissed, setIsDismissed] = useState(() => {
    return localStorage.getItem('upgradePromptDismissed') === 'true';
  });

  // Don't show if already on advanced plan or if dismissed
  if (hasFeature('advanced_loan_management') || isDismissed) {
    return null;
  }

  const handleDismiss = () => {
    localStorage.setItem('upgradePromptDismissed', 'true');
    setIsDismissed(true);
  };

  const handleUpgrade = () => {
    navigate('/upgrade');
  };

  const advancedFeatures = [
    { icon: Shield, text: 'Advanced Loan Management', color: 'text-blue-600' },
    { icon: TrendingUp, text: 'M-Pesa Auto-Collection', color: 'text-green-600' },
    { icon: CheckCircle, text: 'Meeting Management & RSVPs', color: 'text-purple-600' },
    { icon: Zap, text: 'Smart Payment Routing', color: 'text-amber-600' },
  ];

  return (
    <div className="relative bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 rounded-xl shadow-lg p-6 mb-6 border border-indigo-100">
      {/* Dismiss button */}
      <button
        onClick={handleDismiss}
        className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        aria-label="Dismiss"
      >
        <X size={20} />
      </button>

      <div className="flex items-start gap-4">
        {/* Icon */}
        <div className="flex-shrink-0 w-12 h-12 bg-gradient-to-br from-indigo-500 to-purple-600 rounded-lg flex items-center justify-center">
          <Zap className="text-white" size={24} />
        </div>

        {/* Content */}
        <div className="flex-1">
          <h3 className="text-xl font-bold text-gray-900 mb-2">
            Unlock Advanced Features 🚀
          </h3>
          <p className="text-gray-600 mb-4">
            Take your group management to the next level with our Advanced Plan
          </p>

          {/* Features grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mb-5">
            {advancedFeatures.map((feature, index) => {
              const Icon = feature.icon;
              return (
                <div key={index} className="flex items-center gap-2">
                  <Icon className={feature.color} size={18} />
                  <span className="text-sm text-gray-700">{feature.text}</span>
                </div>
              );
            })}
          </div>

          {/* CTA buttons */}
          <div className="flex flex-wrap gap-3">
            <button
              onClick={handleUpgrade}
              className="px-6 py-2.5 bg-gradient-to-r from-indigo-600 to-purple-600 text-white font-semibold rounded-lg hover:from-indigo-700 hover:to-purple-700 transition-all shadow-md hover:shadow-lg"
            >
              Upgrade Now
            </button>
            <button
              onClick={() => navigate('/upgrade')}
              className="px-6 py-2.5 bg-white text-indigo-600 font-semibold rounded-lg hover:bg-indigo-50 transition-colors border border-indigo-200"
            >
              Learn More
            </button>
          </div>

          {/* Small print */}
          <p className="text-xs text-gray-500 mt-3">
            ✨ Special offer: Get 20% off your first 3 months
          </p>
        </div>
      </div>
    </div>
  );
};

export default UpgradePromptCard;
